import { Directive, ElementRef, HostListener, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Validator, FormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[appAllowNumbers]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: AllowNumbersDirective, multi: true },
    ]
})

export class AllowNumbersDirective implements AfterViewInit, Validator {
    @Input() ngModel: string | number;
    @Input() digits: number = 0;
    @Input() currency: boolean | string = false;
    @Input() minlength: number = 0;
    @Input() maxlength: number;

    @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
    private allowKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End'
        , 'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste'];

    //  Regular expressions
    regx: string;

    constructor(private elementRef: ElementRef) {
    }

    ngAfterViewInit() {
        try {
            this.regx = `^([0-9]{${this.minlength},${this.maxlength}})*$`;
            this.digits = this.digits && parseInt(this.digits.toString(), null);
            if (this.digits) {
                const lTrim = this.maxlength - (this.digits + 1);
                this.regx = `^([0-9]{${this.minlength},${lTrim}})(\\.[0-9]{${this.minlength},${this.digits}})*$`;
            }
            if (this.currency === true || this.currency === 'true') {
                this.regx = `^[1-9]\\d*(((\\,\\d*)*)?(\\.\\d{${this.minlength},${this.digits}})?)$`;
            }
        } catch (ex) {
            console.error(`ngAfterViewInit exception ${ex.toString()}`);
        }
    }

    @HostListener('paste', ['$event']) onPaste(event) {
        try {
            event.preventDefault();
        } catch (ex) {
            console.error(`paste exception ${ex.toString()}`);
        }
    }

    // @HostListener('ngModelChange') onChanges(event) {
    // }

    @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
        const isAllowKey = this.allowKeys.some(it => it === event.key);
        // Ensure that it is a number and stop the keypress
        if (isAllowKey) {
            return;
        }
        // '.'(dot) only allow for digit number
        if (this.digits && event.key === '.') {
            return;
        }
        if (event.key === ' ' || isNaN(Number(event.key))) {
            event.preventDefault();
        }
    }

    validate(control: FormControl) {
        const value = control.value;
        if (value) {
            const valid: boolean = this.isValid(this.regx, value);
            return valid ? null : Object.assign({}, { allownumbers: true });
        }
    }

    isValid(regx, value) {
        return new RegExp(regx).test(value);
    }
}
